import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TextEndDirective } from "./TextEndDirective.directive";
import { ResponsiveTableDirective } from "./responsive-table.directive";

@NgModule({
	imports: [CommonModule],
	declarations: [TextEndDirective, ResponsiveTableDirective],
	exports: [TextEndDirective, ResponsiveTableDirective],
})
export class DirectivesModule {}
